import Global from '../../store/global-selectors';
import {
  selectConnectDefaultScale,
  selectConnectScales,
  selectConnectWorkstations,
} from '../../store/shipstation-connect/ss-connect.selectors';
import { scaleGrouper } from '../../services/scale-grouper';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { setDefaultScale } from '../../store/shipstation-connect/ss-connect.actions';

export const useScales = () => {
  const defaultScaleId = useSelector(selectConnectDefaultScale)?.id;
  const workstations = useSelector(selectConnectWorkstations);
  const scaleGroups = useSelector(selectConnectScales);
  const userId = useSelector(Global.selectUserCurrentUserId);

  const dispatch = useDispatch();

  return useMemo(() => {
    if (!scaleGroups) {
      return {};
    }

    let defaultScale = {};
    const enabledScaleGroups = [];

    const scaleGroupCount = scaleGroups?.length ?? 0;
    for (let scaleGroupIndex = 0; scaleGroupIndex < scaleGroupCount; scaleGroupIndex++) {
      const scalesForWorkstation = [];

      const scaleGroup = scaleGroups[scaleGroupIndex];
      const scales = scaleGroup.scales;

      for (let scaleIndex = 0; scaleIndex < scales.length; scaleIndex++) {
        const scale = scales[scaleIndex];
        if (!scale.disabled) {
          if (scale.id === defaultScaleId) {
            defaultScale = scale;
          }

          scalesForWorkstation.push(scale);
        }
      }

      enabledScaleGroups.push({
        workstationId: scaleGroup.workstationId,
        scales: scalesForWorkstation,
      });
    }

    const enabledScalesGroupedByWorkstation = scaleGrouper.groupScalesByWorkstationsForUser(workstations, enabledScaleGroups, userId);

    return {
      scale: defaultScale,
      enabledScalesGroupedByWorkstation,
      onChangeScale: (scale) => dispatch(setDefaultScale(scale)),
    };
  }, [scaleGroups, workstations, userId, defaultScaleId, dispatch]);
};
